import "./App.css";
import { cerrarSession } from "./helpers/AccessHelper";

import {
  Link,
  NavLink,
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Body from "./components/layout/Body/Body";
import Maintenance from "./components/layout/Loads/Maintenance";

import AccesLogin from "./components/layout/Access/AccesLogin";
import AccesRegister from "./components/layout/Access/AccesRegister";
import UpperRegister from "./components/layout/Access/UpperRegister";

import AuthProvider from "./context/auth/AuthContext";
import RouteGuest from "./middleware/Guest";
import Role from "./middleware/Role";

import VistaEvento from "./components/layout/Ticket/Vista";

import Home from "./components/layout/Home/Home";
import RestaurarPassword from "./components/layout/Access/RestaurarPassword";
import ForgotPassword from "./components/layout/Access/ForgotPassword";
import EventosState from "./context/EventosState";
import Entradas from "./components/layout/Entradas/Entradas";
import Salas from "./components/layout/Salas/Salas";
import Sala from "./components/layout/Sala/Sala";
import Somos from "./components/layout/Somos/Somos";
import TYP from "./components/layout/TYP/TYP";
import AcceptPago from "./components/layout/Alert/AcceptPago";
import ErrorCard from "./components/layout/Alert/ErrorCard";
import ConfirmRegistro from "./components/layout/Alert/ConfirmRegistro";
import RestorePassword from "./components/layout/Alert/RestorePassword";
import Cookie from "./components/layout/Cookie/Cookie";
import MedioDePago from "./components/layout/MedioDePago/MedioDePago";
import Notas from "./components/layout/Noticias/Notas";
import Nota from "./components/layout/Noticias/Nota";
import Videos from "./components/layout/Videos/Videos";
import Fiestas from "./components/layout/Fiestas/Fiestas";

/*Dashboard routes*/
import Dashboard from "./components/Dashboard/Dashboard";
import MiCuenta from "./components/Dashboard/Layout/MiCuenta/MiCuenta";
import Eventos from "./components/Dashboard/Layout/Eventos/Eventos";
import ControlSalas from "./components/Dashboard/Layout/Salas/ControlSalas";
import FormEvento from "./components/Dashboard/Layout/Eventos/Add/FormEvento";
import Facturacion from "./components/Dashboard/Layout/Facturacion/Facturacion";
import MisCompras from "./components/Dashboard/Layout/MisCompras/MisCompras";
import ControlProductores from "./components/Dashboard/Layout/Productores/ControlProductores";
import ControlUsuarios from "./components/Dashboard/Layout/Usuarios/ControlUsuarios";
import ControlNotas from "./components/Dashboard/Layout/Notas/ControlNotas";
import FormNotas from "./components/Dashboard/Layout/Notas/Add/FormNotas";
import Configuracion from "./components/Dashboard/Layout/Configuracion/Configuracion";
import Boleteria from "./components/Dashboard/Layout/Boleteria/Boleteria";
import ControlVideos from "./components/Dashboard/Layout/Videos/ControlVideos";
import Cupones from "./components/Dashboard/Layout/Cupones/Cupones";

/*APK ROUTES*/
import Apk from "./App/Layout/Apk";
//Access
import Login from "./App/Layout/Login/Login";
import Box from "./App/Layout/Box/Box";
import PasarelaDePagos from "./components/layout/MedioDePago/PasarelaDePagos";
import Reportes from "./components/Dashboard/Layout/Reportes/Reportes";
import Estadisticas from "./components/Dashboard/Layout/Estadisticas/Estadisticas";
import Espectador from "./components/Dashboard/Layout/Espectador/Index";
import MasterProvider from "./providers/MasterProvider";
import Membresias from "./components/Dashboard/Layout/membresias/Index";
import UsoMembresia from "./components/layout/MedioDePago/UsoMembresia";

//Nueva pagina
import LoginController from "./resource/web/controllers/auth/LoginController";
import StoreProvider from "./resource/providers/StoreProvider";
import { ContextProvider } from "./resource/context/ContextProvider";
import RegisterController from "./resource/web/controllers/auth/RegisterController";
import EventoController from "./resource/web/controllers/eventos/EventoController";
import UsuarioController from "./resource/web/controllers/usuarios/UsuarioController";
import NotaController from "./resource/web/controllers/notas/NotaController";
import EventosController from "./resource/web/controllers/eventos/EventosController";

import NotasController from "./resource/web/controllers/notas/NotasController";
import { NotasController as PublicNotasController } from "./resource/public/controllers/NotasController";
import { NotaController as PublicNotaController } from "./resource/public/controllers/NotaController";

import MembresiasController from "./resource/web/controllers/membresias/MembresiasController";
import BoleteriaController from "./resource/web/controllers/eventos/BoleteriaController";
import InicioController from "./resource/public/controllers/InicioController";
import EntradaController from "./resource/public/controllers/EntradaController";
import PagoController from "./resource/public/controllers/PagoController";
import EntradasController from "./resource/public/controllers/EntradasController";
import SalaController from "./resource/public/controllers/SalaController";
import SalasController from "./resource/public/controllers/SalasController";
import TerminosYCondiciones from "./resource/public/page/TerminosYCondiciones";

import VideosController from "./resource/public/controllers/VideosController";
import { Suspense } from "react";
import CuponController from "./resource/web/controllers/eventos/CuponController";
import CuponesController from "./resource/web/controllers/eventos/CuponesController";
import { HelmetProvider } from "react-helmet-async";
import UsuariosController from "./resource/web/controllers/usuarios/UsuariosController";
import ReportesController from "./resource/web/controllers/reportes/ReportesController";
import ReporteController from "./resource/web/controllers/reportes/ReporteController";

function App() {
  //<Route  exact path='/' element={<Maintenance/>} />
  //<Route exact path='/' element={<Body outSession={cerrarSession}><Home /></Body>} />

  const mantenimiento = false;

  return (
    <HelmetProvider>
      <MasterProvider>
        <AuthProvider>
          <StoreProvider>
            <ContextProvider>
              <Router>
                <EventosState>
                  {mantenimiento ? (
                    <Routes>
                      <Route path="/" element={<Maintenance />} />
                      <Route path="/:mantenimiento" element={<Maintenance />} />
                      <Route
                        path="/:mantenimiento/:mantenimiento/:mantenimiento"
                        element={<Maintenance />}
                      />
                    </Routes>
                  ) : (
                    <Routes>
                      {/* Back Office */}

                      <Route
                        exact
                        path="/dashboard/micuenta"
                        element={
                          <Dashboard>
                            <MiCuenta />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/facturacion"
                        element={
                          <Dashboard>
                            <Facturacion />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/facturacion/:idEvento"
                        element={
                          <Dashboard>
                            <Facturacion />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/miscompras"
                        element={
                          <Dashboard>
                            <MisCompras />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/videos"
                        element={
                          <Dashboard>
                            <ControlVideos />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/configuracion"
                        element={
                          <Dashboard>
                            <Configuracion />
                          </Dashboard>
                        }
                      />

                      {/* Back Office Reportes */}

                      <Route
                        exact
                        path="/dashboard/cuentas"
                        element={
                          <Dashboard>
                            <Reportes />
                          </Dashboard>
                        }
                      />

                      {/* WEB PUBLICA NUEVA */}

                      <Route exact path="/" element={<InicioController />} />

                      <Route
                        exact
                        path="/inicio"
                        element={<InicioController />}
                      />

                      <Route
                        exact
                        path="/entradas/:search"
                        element={<EntradasController />}
                      />

                      <Route
                        exact
                        path="/entradas"
                        element={<EntradasController />}
                      />

                      <Route
                        exact
                        path="/contenidos/videos"
                        element={<VideosController />}
                      />

                      <Route
                        exact
                        path="/contenidos/notas"
                        element={<PublicNotasController />}
                      />

                      <Route
                        exact
                        path="/contenidos/notas/:slug"
                        element={<PublicNotaController />}
                      />

                      <Route
                        exact
                        path="/entrada/:slug"
                        element={<EntradaController />}
                      />

                      <Route
                        exact
                        path="/checkout"
                        element={<PagoController />}
                      />

                      <Route
                        exact
                        path="/salas"
                        element={<SalasController />}
                      />

                      <Route
                        exact
                        path="/sala/:slug"
                        element={<SalaController />}
                      />

                      <Route
                        exact
                        path="/terminos-y-condiciones"
                        element={<TerminosYCondiciones />}
                      />

                      {/* ADMINISTRADOR NUEVO */}

                      {/* AUTH */}

                      <Route
                        exact
                        path="/login"
                        element={<LoginController />}
                      />

                      <Route
                        exact
                        path="/registro/:tipo"
                        element={<RegisterController />}
                      />

                      {/** REPORTES */}

                      <Route
                        exact
                        path="/dashboard/reportes"
                        element={
                          <Dashboard>
                            <ReportesController />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/reportes/nuevo"
                        element={
                          <Dashboard>
                            <ReporteController />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/reportes/:id"
                        element={
                          <Dashboard>
                            <ReporteController />
                          </Dashboard>
                        }
                      />

                      {/* USUARIOS */}

                      <Route
                        exact
                        path="/perfil"
                        element={<UsuarioController />}
                      />
                      <Route exact path="/v/configuracion" element={""} />
                      <Route exact path="/v/usuarios/:tipo" element={""} />

                      {/* EVENTOS */}

                      <Route
                        exact
                        path="/dashboard/eventos/crear"
                        element={
                          <Dashboard>
                            <FormEvento />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/eventos/:id"
                        element={
                          <Dashboard>
                            <EventoController />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/eventos"
                        element={
                          <Dashboard>
                            <EventosController />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/boleteria/:id"
                        element={
                          <Dashboard>
                            <BoleteriaController />
                          </Dashboard>
                        }
                      />

                      <Route
                        exact
                        path="/dashboard/boleteria/:id/:shared_token"
                        element={<BoleteriaController />}
                      />

                      {/** USUARIOS */}

                      <Route
                        exact
                        path="/dashboard/usuarios"
                        element={
                          <Dashboard>
                            <UsuariosController />
                          </Dashboard>
                        }
                      />
                      <Route
                        exact
                        path="/dashboard/usuarios/:id"
                        element={
                          <Dashboard>
                            <UsuarioController />
                          </Dashboard>
                        }
                      />

                      {/** CUPONES */}

                      <Route
                        exact
                        path="/dashboard/cupones"
                        element={
                          <Dashboard>
                            <CuponesController />
                          </Dashboard>
                        }
                      />
                      <Route
                        exact
                        path="/dashboard/cupones/nuevo"
                        element={
                          <Dashboard>
                            <CuponController />
                          </Dashboard>
                        }
                      />
                      <Route
                        exact
                        path="/dashboard/cupones/:id"
                        element={
                          <Dashboard>
                            <CuponController />
                          </Dashboard>
                        }
                      />

                      {/* NOTAS */}

                      <Route
                        exact
                        path="/dashboard/nota/:id"
                        element={
                          <Dashboard>
                            <NotaController />
                          </Dashboard>
                        }
                      />
                      <Route
                        exact
                        path="/dashboard/notas"
                        element={
                          <Dashboard>
                            <NotasController />
                          </Dashboard>
                        }
                      />

                      {/* MEMBRESIAS */}

                      <Route
                        exact
                        path="/dashboard/membresias"
                        element={
                          <Dashboard>
                            <MembresiasController />
                          </Dashboard>
                        }
                      />
                    </Routes>
                  )}
                </EventosState>
              </Router>
            </ContextProvider>
          </StoreProvider>
        </AuthProvider>
      </MasterProvider>
    </HelmetProvider>
  );
}

export default App;
